import { AxiosInstance, AxiosError } from "axios";
import { BaseApi } from "../base-api";
import {
  IGetAccountQuicksightRequestModel,
  IGetAccountQuicksightResponseModel,
  IQuicksightApi,
} from "@lib/types";

export class QuicksightApi extends BaseApi implements IQuicksightApi {
  constructor(instance: AxiosInstance) {
    super(instance);
  }

  async get(
    requestModel: IGetAccountQuicksightRequestModel,
  ): Promise<IGetAccountQuicksightResponseModel> {
    try {
      const response =
        await this._instance.post<IGetAccountQuicksightResponseModel>(
          "/web/quicksight",
          requestModel,
        );

      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw error;
      }
      throw new Error("Unknown error");
    }
  }
}
